<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Cartola de Cliente
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta Corriente Cliente</span>
      <span> /</span>
      <span>Cartola Cliente</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form autocomplete="off" [formGroup]="formHeader" (ngSubmit)="buscar(true)">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" class="form-control" placeholder="" required formControlName="rut" formatRut />
            <label for="rutcliente">RUT</label>
            <div *ngIf="
                formHeader.get('rut').invalid &&
                (formHeader.get('rut').dirty ||
                formHeader.get('rut').touched)
              ">
              <mdb-error *ngIf="formHeader.get('rut').hasError('required')">Ingrese cliente
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 400px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarCliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" *ngIf="clienteSeleccionado" style="display: contents;">
            {{ clienteSeleccionado.razon_social }}
          </h6>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde">
            </mdb-date-picker>
            <div *ngIf="
                        formHeader.get('fechaDesde').invalid &&
                        (formHeader.get('fechaDesde').dirty ||
                        formHeader.get('fechaDesde').touched)
                      ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta">
            </mdb-date-picker>
            <div *ngIf="
                        formHeader.get('fechaHasta').invalid &&
                        (formHeader.get('fechaHasta').dirty ||
                        formHeader.get('fechaHasta').touched)
                      ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha
              </mdb-error>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </form>
</div>

<div class="card mb-2 wow detalle-cliente" *ngIf="listaRegistros && totales">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="listaRegistros">

      <a mdbBtn color="info" class="waves-light" mdbWavesEffect *ngIf="listaRegistros?.length === 0">
        No existen movimientos en el rango de fechas solicitado
      </a>

      <!-- *ngIf="listaRegistros?.length > 0" -->
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2" *ngIf="listaRegistros?.length > 0">
          <tr>
            <th scope="col">Documento</th>
            <th scope="col">Fecha Pag./Doc.</th>
            <th scope="col">Fecha Venc.</th>
            <th scope="col">Ref. Doc. Nro.</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-right">Cargo</th>
            <th scope="col" class="text-right">Abono</th>
            <th scope="col" class="text-right">Saldo</th>
          </tr>
        </thead>
        <tbody *ngIf="listaRegistros?.length > 0">
          <ng-container *ngFor="let registro of listaRegistros">
            <tr>
              <td *ngIf="registro.pago_codigo > 0" (click)="loadAndShowDetallePago(registro)" class="custom_link">{{registro.documento }}</td>
              <td *ngIf="registro.pago_codigo === 0">{{ registro.documento }}</td>
              <td>{{ registro.fecha_registro | fecha }}</td>
              <td>{{ registro.fecha_vencimiento | fecha }}</td>
              <td>{{ registro.referencia_documento }}</td>
              <td align="right">{{ registro.monto | numerico }}</td>
              <td align="right">{{ registro.cargo | numerico }}</td>
              <td align="right">{{ registro.abono | numerico }}</td>
              <td align="right">{{ registro.saldo | numerico }}</td>
            </tr>
            <tr *ngFor="let mov of registro.listaPagos" class="fila-pago">
              <td>{{ mov.tipo_pago_nombre }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="text-right">{{ mov.monto | numerico }}</td>
              <td ></td>
            </tr>
          </ng-container>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaRegistros?.length > 0"></app-pagination>
        <tbody class="blue lighten-5">
          <tr>

            <td align="right" colspan="5">Saldos finales</td>
            <td align="right"><strong>$ {{ totales.cargo | numerico }}</strong></td>
            <td align="right"><strong>$ {{ totales.abono | numerico }}</strong></td>
            <td align="right"><strong>$ {{ totales.monto | numerico }}</strong></td>
          </tr>
          <tr>
            <td align="right" colspan="7">Abonos por aplicar</td>
            <td align="right">$ {{ abonosPorAplicar | numerico }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaRegistros?.length > 0 && totales">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
      Excel
    </button>
    <button mdbBtn type="button" color="primary" mdbWavesEffect class="btn" (click)="downloadPDF()">
      PDF
    </button>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" (onSelectSingle)="onClienteSeleccionado($event)"
  queryType="ONLY_RUT_BLO_DESB" showInfoClienteInactivoBloqueado="true" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL verPago-->
<app-modal-view-details-pago></app-modal-view-details-pago>
